export const statsData = [
  {
    id: 1,
    value: 120,
    suffix: "+",
    label: "DIGITAL ARCHITECTURES DEPLOYED",
    description: "From complex ERPs to viral marketing campaigns. We have built systems that work."
  },
  {
    id: 2,
    value: 125,
    prefix: "$",
    suffix: "M+",
    label: "CLIENT REVENUE GENERATED",
    description: "We don't just build software; we build revenue engines. This is the estimated impact of our solutions."
  },
  {
    id: 3,
    value: 3,
    label: "CONTINENTS ACTIVE",
    description: "Operations spanning India, UAE, and USA. We understand global markets because we live in them."
  },
  {
    id: 4,
    value: 72,
    suffix: "h",
    label: "RECORD DEPLOYMENT TIME",
    description: "The fastest MVP turnaround in our history. Speed is our currency."
  }
]

export const legacyData = {
  established: 2018,
  company: "Oman Enterprises",
  description: "Quavrion is not a startup. It is the specialized technology division of Oman Enterprises. We carry a 7-year legacy of business excellence, rebranded and engineered for the AI era. You get the agility of a tech firm with the stability of a holding company."
}

export const partnerLogos = [
  { name: "AWS", category: "infrastructure" },
  { name: "Google Cloud", category: "infrastructure" },
  { name: "Meta", category: "marketing" },
  { name: "Google Ads", category: "marketing" },
  { name: "Shopify", category: "commerce" },
  { name: "Amazon", category: "commerce" },
  { name: "Microsoft", category: "infrastructure" },
  { name: "React", category: "development" },
  { name: "Python", category: "development" },
  { name: "Node.js", category: "development" }
]